import { useEffect, useState } from "react";
import { isApiError } from "../../api/client.js";
import { getSuperAdminMe } from "../../api/super-admin-api.js";

/**
 * True only after GET /super-admin/me succeeds. A 403 stays false and is not shown.
 */
export function useSuperAdminAccess(): boolean {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    getSuperAdminMe(controller.signal).then(
      () => {
        if (!controller.signal.aborted) setAllowed(true);
      },
      (error: unknown) => {
        if (controller.signal.aborted) return;
        if (isApiError(error) && error.status === 403) {
          setAllowed(false);
          return;
        }
        setAllowed(false);
      },
    );
    return () => controller.abort();
  }, []);

  return allowed;
}
